import './Maintenance.css';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

function MaintenancePage() {

  const { t: tLogin } = useTranslation('login');

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    }}>
      <div className='manutencao-box'>
        <img src='imagens/iris.svg' alt="Error" className="error-image" />
        <h1 className="error-title">{tLogin('mantenance-message')}</h1>
        <p className="error-message">{tLogin('mantenance-message2')}</p>
      </div>
    </div>
  );
}

export default MaintenancePage;